/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function libraryBundlePackageVisit() {
  pushClevertapEvent('BO Bundle Package Visit');
}

export function libraryBundlePackageCreate(bundle, user) {
  const { name, bundle_components, outlet_ids, is_active, sales_types } =
    bundle;
  const bundleComponents = bundle_components.map((b) => b.item_name);
  const isMultiplePrice = sales_types.length > 0;

  pushClevertapEvent('BO Bundle Package Create', {
    'Bundle Name': name,
    'Bundle Component': bundleComponents,
    'Total Bundle Component': bundleComponents.length,
    'Business ID': user.businessId,
    'Business Type': user.businessType,
    'Outlet Assign': outlet_ids.length,
    'Is Multiple Price': isMultiplePrice,
    'Is Active': is_active,
  });
}

export function libraryBundlePackageUpdate(oldBundle, bundle, user) {
  const { name, bundle_components, outlet_ids, is_active, sales_types } =
    bundle;
  const bundleComponents = bundle_components.map((b) => b.item_name);
  const isMultiplePrice = sales_types.length > 0;

  const outletCreated = outlet_ids.filter(
    (outlet_id) => !oldBundle.outlet_ids.includes(outlet_id)
  );

  const outletDeleted = oldBundle.outlet_ids.filter(
    (outlet_id) => !bundle.outlet_ids.includes(outlet_id)
  );

  const isPriceChanged =
    bundle.basic_price !== oldBundle.basic_price ||
    bundle.sales_types.length > 0 !== oldBundle.sales_types.length > 0;

  pushClevertapEvent('BO Bundle Package Update', {
    'Old Bundle Name': oldBundle.name,
    'Old Bundle Components': oldBundle.bundle_components.map(
      (b) => b.item_name
    ),
    'Old Total Bundle Components': oldBundle.bundle_components.length,
    'Old Total Outlet Assign': oldBundle.outlet_ids.length,
    'Old Is Multiple Price': oldBundle.sales_types.length > 0,
    'Old Is Active': oldBundle.is_active,
    'New Bundle Name': name,
    'New Bundle Component': bundleComponents,
    'New Total Bundle Component': bundleComponents.length,
    'New Outlet Assign': outlet_ids.length,
    'New Is Multiple Price': isMultiplePrice,
    'New Is Active': is_active,
    'Business ID': user.businessId,
    'Outlet Changed': outletCreated.length + outletDeleted.length,
    'Is Price Changed': isPriceChanged,
  });
}

export function libraryBundlePackageDelete(bundle, businessId) {
  const { name, bundle_components, outlet_ids, is_active, sales_types } =
    bundle;
  const bundleComponents = bundle_components.map((b) => b.item_name);
  const isMultiplePrice = sales_types.length > 0;

  pushClevertapEvent('BO Bundle Package Delete', {
    'Bundle Name': name,
    'Bundle Component': bundleComponents,
    'Business ID': businessId,
    'Old Outlet Assign': outlet_ids.length,
    'New Outlet Assign': 0,
    'Outlet Changed': outlet_ids.length,
    'Is Multiple Price': isMultiplePrice,
    'Is Active': is_active,
  });
}

export function libraryBundlePackageNameErrorUniqueness(bundle, user, action) {
  pushClevertapEvent('BO Bundle Package Name Error Uniqueness', {
    Name: bundle.name,
    'Business ID': user.businessId,
    Action: action,
    'User Email': user.email,
    'User Phone Number': user.phone,
  });
}
